import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Leaf, 
  Sparkle, 
  Wrench, 
  Question, 
  Heart, 
  Headset
} from '@phosphor-icons/react';
import HelpApiLayout from '../../components/layout/HelpApiLayout';
import HelpSidebar from '../../components/layout/HelpSidebar';
import CategoryCard from './components/CategoryCard';
import LastUpdated from '../../components/layout/docs/LastUpdated';
import { PUBLIC_ROUTES } from '../../constants/routes';
import { getHelpRoute } from '../../utils/navigation';
import './HelpCenter.css';

/**
 * Help Center Main Page
 * Landing page with category cards and search functionality
 */
const HelpCenter = () => {
  const categories = [
    {
      id: 'getting-started',
      title: 'Getting Started',
      description: 'Set up your account and create your first group in minutes.',
      route: getHelpRoute(PUBLIC_ROUTES.HELP_GETTING_STARTED),
      icon: Leaf
    },
    {
      id: 'features',
      title: 'Features',
      description: 'Learn about splitting methods, currencies, and expense tracking.',
      route: getHelpRoute(PUBLIC_ROUTES.HELP_FEATURES),
      icon: Sparkle
    },
    {
      id: 'integrations',
      title: 'Integrations',
      description: 'Connect with partner apps to split your payments instantly.',
      route: getHelpRoute('/help/integrations'),
      icon: Wrench
    },
    {
      id: 'faq',
      title: 'FAQ',
      description: 'Quick answers to the most common questions.',
      route: getHelpRoute('/help/faq'),
      icon: Question
    },
    {
      id: 'community',
      title: 'Community',
      description: 'Join the conversation and help us shape the future of WeSplit.',
      route: getHelpRoute('/help/community'),
      icon: Heart
    },
    {
      id: 'support',
      title: 'Need Help?',
      description: 'Get support instantly via Telegram or email.',
      route: getHelpRoute('/help/support'),
      icon: Headset
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Welcome to the WeSplit Help Center 👋</h1>
            <p className="lp-section-subtitle">
              Search for an answer or browse the topics below to get started.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="help-center-cards">
              {categories.map((category) => (
                <CategoryCard
                  key={category.id}
                  title={category.title}
                  description={category.description}
                  route={category.route}
                  icon={category.icon}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default HelpCenter;
